import { ApolloClient } from '@apollo/client';
import { get } from 'lodash';
import logger from '../common/helpers/logger/logger';
import { PROJECT_PAGE_QUERY } from '../queries/projectPage/project';
import {
  PROJECT_ARTICLES_QUERY,
  ProjectArticleData,
} from '../queries/projectPage/projectArticles';
import {
  ProjectNearbyQueryRequest,
  ProjectNearbyQueryResponse,
  PROJECT_NEARBY_QUERY,
} from '../queries/projectPage/projectNearby';

interface FetchProjectDetailsOptions {
  id: number;
}
export const fetchProjectDetails = async (
  client: ApolloClient<unknown>,
  options: FetchProjectDetailsOptions,
) => {
  try {
    logger.logInfo('projectService.fetchProjectDetails', 'Begin', options);

    const variables = {
      id: options.id,
      errorPolicy: 'all',
    };

    const response = await client.query({
      query: PROJECT_PAGE_QUERY,
      variables: variables,
    });
    return get(response, 'data', {});
  } catch (error) {
    logger.logError(
      'projectService.fetchProjectDetails',
      'Error retrieving from query.',
      {
        options,
        error,
      },
    );
    throw error;
  }
};

interface FetchNearbyProjectsOptions {
  projectId: number;
  locationDistrictId: number;
}
export const fetchNearbyProjects = async (
  client: ApolloClient<unknown>,
  options: FetchNearbyProjectsOptions,
): Promise<ProjectNearbyQueryResponse | undefined> => {
  try {
    logger.logInfo('projectService.fetchNearbyProjects', 'Begin', options);

    const variables = {
      id: options.projectId,
      locationDistrictId: options.locationDistrictId,
    };

    const response = await client.query<
      ProjectNearbyQueryResponse,
      ProjectNearbyQueryRequest
    >({
      query: PROJECT_NEARBY_QUERY,
      variables: variables,
    });
    return get(response, 'data', {});
  } catch (error) {
    logger.logError(
      'projectService.fetchNearbyProjects',
      'Error retrieving from query.',
      {
        options,
        error,
      },
    );
    throw error;
  }
};

interface FetchProjectArticlesOptions {
  projectId: number;
  excludeId?: number;
}
export const fetchProjectArticles = async (
  client: ApolloClient<unknown>,
  options: FetchProjectArticlesOptions,
): Promise<ProjectArticleData> => {
  try {
    logger.logInfo('projectService.fetchProjectArticles', 'Begin', options);

    const variables = {
      id: options.projectId,
      exclude: options.excludeId,
    };

    const response = await client.query({
      query: PROJECT_ARTICLES_QUERY,
      variables: variables,
    });
    return get(response, 'data', {});
  } catch (error) {
    logger.logError(
      'projectService.fetchProjectArticles',
      'Error retrieving from query.',
      {
        options,
        error,
      },
    );
    throw error;
  }
};
